import { post, get, request } from "./http.js";
//公共接口
/**
 * 卖家、买家登录
 * @param {*} data 
 * @returns 
 */
const userLogin = (data) => post("user/login", data);
/**
 * 买家注册
 * @param {*} data 
 * @returns 
 */
const userRegister = (data) => post("user/register", data);
/**
 * 卖家注册
 * @param {*} data 
 * @returns 
 */
const userSellerRegister = (data) => post("user/seller_register", data);
/**
 * 获取账号信息
 * @param {*} data 
 * @returns 
 */
const userIndex = (data) => post("user/index", data);
/**
 * 商品列表
 * @param {*} data 
 * @returns 
 */
const indexProductlist = (data) => post("index/productlist", data);
/**
 * 商品详情
 * @param {*} data 
 * @returns 
 */
const indexProductdetail = (data) => post("index/productdetail", data);
/**
 * 添加评论
 * @param {*} data 
 * @returns 
 */
const indexAddcomment = (data) => post("index/addcomment", data);
/**
 * 添加、取消收藏
 * @param {*} data 
 * @returns 
 */
const indexSetcollect = (data) => post("index/setcollect", data);
/**
 * 获取产品分类
 * @param {*} data 
 * @returns 
 */
const indexProductcate = (data) => post("index/productcate", data);
/**
 * 获取FAQ
 * @param {*} data 
 * @returns 
 */
const indexGetfaq = (data) => post("index/getfaq", data);
/**
 * 得到配置数据
 * @param {*} data 
 * @returns 
 */
const indexGetconfig = (data) => post("index/getconfig", data);
/**
 * 积分提现
 * @param {*} data 
 * @returns 
 */
const userCashout = (data) => post("user/cashout", data);
/**
 * 收藏列表
 * @param {*} data 
 * @returns 
 */
const indexCollectlist = (data) => post("index/collectlist", data);
/**
 * 买家信息编辑
 * @param {*} data 
 * @returns 
 */
const userEditinfo = (data) => post("user/editinfo", data);
/**
 * 卖家信息编辑
 * @param {*} data 
 * @returns 
 */
const userEditsellerinfo = (data) => post("user/editsellerinfo", data);
/**
 * 发布产品、编辑产品
 * @param {*} data 
 * @returns 
 */
const userPublish = (data) => post("user/publish", data);
/**
 * 更新用户购买链接点击次数
 * @param {*} data 
 * @returns 
 */
const indexUpdatetimes = (data) => post("index/updatetimes", data);
/**
 * 发送邮箱验证码
 * @param {*} data 
 * @returns 
 */
const userSendyzm = (data) => post("user/sendyzm", data);
/**
 * 买家、卖家忘记密码
 * @param {*} data 
 * @returns 
 */
const userResetpwd = (data) => post("user/resetpwd", data);
/**
 * 联系我们
 * @param {*} data 
 * @returns 
 */
const indexContactus = (data) => post("index/contactus", data);
/**
 * 上传图片
 * @param {*} data 
 * @returns 
 */
const indexUploadimg = (data) => post("index/uploadimg", data);

/**
 * 订单列表
 * @param {*} data 
 * @returns 
 */
const indexOrderlist = (data) => post("index/orderlist", data);
/**
 * 订单详情
 * @param {*} data 
 * @returns 
 */
const indexOrderdetail = (data) => post("index/orderdetail", data);
/**
 * 商家完成订单
 * @param {*} data 
 * @returns 
 */
const indexFinishorder = (data) => post("index/finishorder", data);


export default {
    userLogin,
    userRegister,
    userSellerRegister,
    userIndex,
    indexProductlist,
    indexProductdetail,
    indexAddcomment,
    indexSetcollect,
    indexProductcate,
    indexGetfaq,
    indexGetconfig,
    userCashout,
    indexCollectlist,
    userEditinfo,
    userEditsellerinfo,
    userPublish,
    indexUpdatetimes,
    userSendyzm,
    userResetpwd,
    indexContactus,
    indexUploadimg,

    indexOrderlist,
    indexOrderdetail,
    indexFinishorder,













}